import { render, staticRenderFns } from "./serviceAgreement.vue?vue&type=template&id=ba3437f6&scoped=true"
import script from "./serviceAgreement.vue?vue&type=script&lang=js"
export * from "./serviceAgreement.vue?vue&type=script&lang=js"
import style0 from "./serviceAgreement.vue?vue&type=style&index=0&id=ba3437f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3437f6",
  null
  
)

export default component.exports